export const ink = "#0B0A08";
export const gold = "#C8A459";
export const canvas = "#F6F5F1";
export const muted = "#6E665A";
export const line = "#E5E2DA";
export const late = "#8F1D1D";
export const lateWash = "#F8EDEC";
export const lateLine = "#D7B4B0";

export const tableCardSx = {
    elevation: 0,
    boxShadow: "none",
    border: "1px solid",
    borderColor: line,
    overflow: "hidden",
    bgcolor: "#fff",
};

export const tableHeadCellSx = {
    bgcolor: canvas,
    borderBottom: `1px solid ${line}`,
    color: muted,
    fontWeight: 600,
    fontSize: 12,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
    py: 1.5,
    px: 2,
};

export const tableBodyCellSx = {
    borderBottom: `1px solid ${line}`,
    py: 1.5,
    px: 2,
    fontSize: 14,
    color: ink,
    "& .MuiTypography-root": {
        textAlign: "inherit",
    },
};

export const tableRowSx = {
    "&:hover": {
        bgcolor: "rgba(200,164,89,0.06)",
    },
    "&:last-of-type td": {
        borderBottom: "none",
    },
};

export const tableRowOverdueSx = {
    bgcolor: lateWash,
    boxShadow: `inset 3px 0 0 ${late}`,
    "&:hover": {
        bgcolor: "#F3E0DE",
    },
    "&:last-of-type td": {
        borderBottom: "none",
    },
};
